import { cx } from '../../ui/classNames';

// The theme's semantic tones (MUI's status chip colours): text, fill, border.
const STATUS_TAG_TONE_CLASS_NAMES = Object.freeze({
    warning: 'border-ui-warning-line bg-ui-warning-bg text-ui-warning',
    info: 'border-ui-info-line bg-ui-info-bg text-ui-info',
    danger: 'border-ui-danger-line bg-ui-danger-bg text-ui-danger',
});

/**
 * A compact pill that fits a 38px grid row: "Adding", "In Watchlist", in the
 * `role` tone ('warning', 'info' or 'danger').
 */
export function statusTagClassName(role) {
    return cx(
        'box-border inline-flex h-5 shrink-0 items-center whitespace-nowrap rounded-[10px] border border-solid',
        'px-1.5 text-[11px] font-bold leading-[18px] tracking-normal',
        STATUS_TAG_TONE_CLASS_NAMES[role],
    );
}
